import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  signal,
  WritableSignal
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseDialogDirective } from '../../../../../shared/components/base/base-dialog.directive';
import {
  ButtonSize,
  ButtonStyle
} from '../../../../../shared/enums/button.enum';
import { AddressPipe } from '../../../../../shared/pipes/address.pipe';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { DialogWrapperComponent } from '../../../../../shared/components/wrappers/dialog-wrapper/dialog-wrapper.component';
import { FormsModule } from '@angular/forms';
import {
  CheckoutAddDeliveryAddressDialogComponent,
  CheckoutAddDeliveryAddressDialogResult
} from '../checkout-add-delivery-address-dialog/checkout-add-delivery-address-dialog.component';
import { filter } from 'rxjs';
import { DialogRef } from '@angular/cdk/dialog';
import { RadioComponent } from '../../../../../shared/components/controllers/radio/radio.component';
import { NgClass } from '@angular/common';
import {
  WooCommerceDeliveryAddress,
  WooCommerceShippingAddress
} from '../../../../../core/interfaces/woo-commerce/api/woo-commerce-api.interface';
import { ShippingMethod } from '../../../../../core/enums/woo-commerce/shipping/shipping.enum';
import { WooCommerceShippingMethod } from '../../../../../core/interfaces/woo-commerce/api/shipping/shipping-api.interface';

export interface CheckoutSelectAddressDialogResponse {
  addressList: Array<WooCommerceDeliveryAddress | WooCommerceShippingAddress>;
  selectedAddress: WooCommerceDeliveryAddress | WooCommerceShippingAddress;
}

@UntilDestroy()
@Component({
  selector: 'app-checkout-delivery-address-dialog',
  imports: [
    AddressPipe,
    ButtonComponent,
    DialogWrapperComponent,
    FormsModule,
    RadioComponent,
    NgClass
  ],
  templateUrl: './checkout-delivery-address-dialog.component.html',
  styleUrl: './checkout-delivery-address-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutDeliveryAddressDialogComponent extends BaseDialogDirective<CheckoutSelectAddressDialogResponse> {
  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonStyle = ButtonStyle;
  protected readonly ShippingMethod = ShippingMethod;

  protected readonly shippingMethod: ShippingMethod =
    this.dialogData?.['shippingMethod'] || ShippingMethod.Pickup;
  protected readonly editable: boolean = this.dialogData?.['editable'] || false;
  protected readonly checkDelivery: boolean =
    this.dialogData?.['checkDelivery'] ?? true;
  protected readonly addressList: Array<
    WooCommerceDeliveryAddress | WooCommerceShippingAddress
  > =
    this.dialogData?.['addressList'] || [];

  selectedAddressIndex: WritableSignal<number> = signal<number>(-1);

  constructor(public changeDetectionRef: ChangeDetectorRef) {
    super();
  }

  onAddAddressClick(): void {
    const dialogRef: DialogRef<
      CheckoutAddDeliveryAddressDialogResult,
      CheckoutAddDeliveryAddressDialogComponent
    > = this.dialog.open(CheckoutAddDeliveryAddressDialogComponent, {
      data: { title: 'Add New Address', checkDelivery: this.checkDelivery },
      width: '100%',
      minHeight: '265px',
      maxWidth: '550px'
    });

    dialogRef.closed.pipe(filter((result) => result != null)).subscribe({
      next: (result: CheckoutAddDeliveryAddressDialogResult) => {
        this.addressList.push(result.address);
        this.changeDetectionRef.markForCheck();
      }
    });
  }

  onSubmit(): void {
    this.closeDialog({
      addressList: this.addressList,
      selectedAddress: this.addressList[this.selectedAddressIndex()]
    });
  }

  isDeliveryAddressAvailable(
    address: WooCommerceDeliveryAddress | WooCommerceShippingAddress
  ): boolean {
    if (
      !('shipping_methods' in address) ||
      !Array.isArray(address.shipping_methods) ||
      !address.shipping_methods.length
    ) {
      return false;
    }

    return address.shipping_methods.some(
      (shippingMethod: WooCommerceShippingMethod) => {
        return !shippingMethod.id.includes('pickup');
        // const shippingPrice = Number.parseFloat(
        //   shippingMethod.cost || shippingMethod.instance_settings?.cost || '0'
        // );
        //
        // return (
        //   isDeliveryMethod &&
        //   Number.isFinite(shippingPrice) &&
        //   shippingPrice > 0
        // );
      }
    );
  }
}
